const getUserInfo = () => JSON.parse(localStorage.getItem('userInfo')) || { roles: [], organization: {} }
const getUserTokens = () => JSON.parse(localStorage.getItem('tokens')) || {}
const getImpersonation = () => JSON.parse(localStorage.getItem('impersonation')) || null

export default {
  activeUser: getUserInfo(),
  activeUserTokens: getUserTokens(),
  impersonation: getImpersonation(),
  showInitTeamPopup: false,
  fetchingUserInfo: false,
  notifications: [],
  isUserLoggedIn: () => {
    let isAuthenticated = true
    if (!localStorage.getItem('userInfo')) {
      isAuthenticated = false
    }
    return isAuthenticated
  },
}
